import { render, staticRenderFns } from "./DocStatusUpdate.vue?vue&type=template&id=79ded2b8&scoped=true&"
import script from "./DocStatusUpdate.vue?vue&type=script&lang=js&"
export * from "./DocStatusUpdate.vue?vue&type=script&lang=js&"
import style0 from "./DocStatusUpdate.vue?vue&type=style&index=0&id=79ded2b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ded2b8",
  null
  
)

export default component.exports